import Link from "next/link";

function LogoMark({ className = "logo-mark" }: { className?: string }) {
  return (
    <div className={className}>
      <svg width="18" height="18" viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <path d="M16 48V27a16 16 0 0 1 32 0v21" stroke="#F1F0EC" strokeWidth="8" strokeLinecap="butt" />
      </svg>
    </div>
  );
}

export function LogoWordmark() {
  return <span aria-label="Vilatio" className="logo-wordmark">Vilatio</span>;
}

export default function Navbar() {
  return (
    <nav className="landing-nav">
      <Link className="logo" href="/">
        <LogoMark />
        <LogoWordmark />
      </Link>
      <div className="nav-links">
        <Link href="/">Inicio</Link>
        <Link href="/#features">Producto</Link>
        <Link href="/canales">Canales</Link>
        <Link href="/#seo">SEO</Link>
        <Link href="/#pricing">Precios</Link>
        <Link href="/#contacto">Contacto</Link>
        <Link href="/login" className="btn-ghost">
          Iniciar sesión
        </Link>
        <Link href="/register" className="btn-primary">
          Solicitar demo
        </Link>
      </div>
    </nav>
  );
}

export { LogoMark };
